var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import i18n from "../../../strings/i18n";
import { MakeAPaymentWrap } from "./MakeAPaymentButton.styles";
var MakeAPaymentButton = function (_a) {
    var handleClick = _a.handleClick, handleCBRClick = _a.handleCBRClick, isManageBalance = _a.isManageBalance, shouldShowViewPaymentPlanOrOption = _a.shouldShowViewPaymentPlanOrOption, handleViewPaymentPlanOrOption = _a.handleViewPaymentPlanOrOption, shouldShowViewPaymentOptions = _a.shouldShowViewPaymentOptions, showPaymentButton = _a.showPaymentButton, showAutopay = _a.showAutopay;
    /**
     * The CBR button takes precedence over the View Payment Plan button
     * so if the value of isManageBalance is true then CBR should be displayed
     * instead of View Payment Plan
     */
    if (isManageBalance) {
        return (_jsx(MakeAPaymentWrap, __assign({ "data-reason": "manage credit balance", "data-type": "manage credit balance", "data-object": "button", "data-analytics": "clicktrackingevent", buttonType: "secondary", onClick: handleCBRClick, isCBRButton: true }, { children: i18n({ labels: "manageYourCreditBalanceBtn" }) })));
    }
    if (showPaymentButton) {
        return (_jsx(MakeAPaymentWrap, __assign({ "data-reason": "make a payment", "data-type": "payment", "data-object": "button", "data-analytics": "clicktrackingevent", buttonType: showAutopay ? "primary" : "secondary", onClick: handleClick }, { children: i18n({ labels: "makeAPaymentBtn" }) })));
    }
    var viewPaymentText = shouldShowViewPaymentOptions
        ? "paymentOptions"
        : "paymentPlan";
    if (shouldShowViewPaymentPlanOrOption &&
        !isManageBalance &&
        !!handleViewPaymentPlanOrOption) {
        return (_jsx(MakeAPaymentWrap, __assign({ "data-reason": viewPaymentText, "data-type": "manage collections hub", "data-object": "button", "data-analytics": "clicktrackingevent", buttonType: "secondary", onClick: handleViewPaymentPlanOrOption }, { children: i18n({ button: viewPaymentText }) })));
    }
    return null;
};
export default MakeAPaymentButton;
//# sourceMappingURL=MakeAPaymentButton.js.map